import { getResponseParseService } from 'services/ResponseParseService'
import { makeSpinRequest } from 'services/ServerService'

const name = 'REQUEST-GAMBLE'

async function execute() {
  const lines = game.models.SpinModel.get().lines
  const action = 'double'

  const checkCard = () => {
    return new Promise((resolve) => {
      const check = () => {
        const card = game.models.GambleModel.getCard()
        if (card === null) {
          setTimeout(check, 200)
        }
        else {
          resolve()
        }
      }

      check()
    })
  }
  await checkCard()

  const response = await makeRequest({
    action: action,
    token: game.models.GameModel.token,
    card: game.models.GambleModel.getCard(),
    params: {
      bet: game.models.BetModel.getValue() / game.models.SpinModel.get().lines,
      lines,
    },
    platform: game.models.GameModel.platform,
    m: game.models.GameModel.m,

  })
  getResponseParseService().parse(response)
}

function makeRequest(data) {
  return makeSpinRequest(data)
}

export function getRequestGambleAction() {
  return {
    name,
    execute,
  }
}
